export default "__VITE_ASSET__42a936bf__"